export const formattedDeliveryInfo = {
  methods: {
    formatDeliverySpotsInfo (spotsInfo, slug, isThankYouPage) {
      const formattedDeliveryInfo = []

      if (slug === 'novaPoshtaWarehouse' || slug === 'novaPoshtaParcel') {
        spotsInfo.forEach(spot => {
          const {
            ref,
            post_office_number: officeNumber,
            description_ru: addressRu,
            description_uk: addressUk,
            latitude,
            longitude,
            isActive,
            schedule,
            total_max_weight: maxWeight,
            is_available: isAvailable
          } = spot

          const formattedSpot = {
            description_ru: addressRu || addressUk,
            isActive,
            latitude,
            longitude,
            schedule,
            maxWeight,
            officeNumber,
            isAvailable,
            uid: ref
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else if (slug === 'pickup') {
        spotsInfo.forEach(spot => {
          const { address, coordinates, working_hours: workingHours, phone, uid, cart_status: cartStatus, store_type: type } = spot

          const formattedSpot = {
            description_ru: address,
            latitude: coordinates[0],
            longitude: coordinates[1],
            schedule: workingHours ? workingHours.replace(/, /gi, '<br/>') : '',
            phone,
            uid,
            cartStatus,
            status: cartStatus,
            type
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else if (slug === 'availability') {
        spotsInfo.forEach(spot => {
          const { store_uid: storeUid, store_id: storeId, quantity, status, static_map_link: staticMapLink, is_in_wait_list: isInWaitList } = spot
          const { address, coordinates, working_hours: workingHours, phone, google_link: googleLink } = spot.store_data

          const formattedSpot = {
            description_ru: address,
            title: address,
            latitude: +coordinates[0],
            longitude: +coordinates[1],
            schedule: workingHours ? workingHours.replace(/, /gi, '<br/>') : '',
            phone,
            storeUid,
            storeId,
            quantity,
            status,
            googleLink,
            staticMapLink,
            isInWaitList
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else {
        spotsInfo.forEach(spot => {
          const { address, latitude, longitude, phone, index } = spot

          const formattedSpot = { description_ru: address, latitude, longitude, phone, uid: index }
          formattedDeliveryInfo.push(formattedSpot)
        })
      }

      if (isThankYouPage) formattedDeliveryInfo[0].isSuccessful = true

      return formattedDeliveryInfo
    }
  }
}
